/**
 * [pug template]
 */
<template lang="pug">
  .selection-alt-choice-container.cmd-side-container(:class="cssClasses")
      label.selection-alt-choice-container-item(v-for="value, valueRef in options", :value="valueRef", :for="valueRef", v-if="value.display", :disabled="value.disabled", :class="{'selected': (selected === valueRef)}")
        .selection-alt-choice-picture-container
          div(v-text="value.label", class="txt-button")
          //- img(:src="value.picture" :class="{ 'selected': (selected === valueRef) , 'single': (Object.keys(options).length == 1),'bande-img': (valueRef === 'OPT-1193_gauche') }")
          input(type="radio", :id="valueRef", :name="valueRef", :value="valueRef", v-model="selected", v-if="value.display", :disabled="value.disabled")
          //- label(v-text="value.label" :class="{ 'selected': (selected === valueRef) }")
          //- label(v-text="valueRef")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'select-with-text-component',
  props: {
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: [Array, Object],
      default: { label: '', display: true, disabled: false }
    },
    defaultField: {
      type: [String, Number],
      default: null
    },
    cssClasses: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      selected: null
    }
  },
  created: function () {
    this.selected = this.defaultField
  },
  watch: {
    selected: function (newValue, oldValue) {
      var dataEmit = newValue
      this.$emit('value-changed', dataEmit)
    },
    defaultField: function (newValue, oldValue) {
      this.selected = newValue
    }
  },
  methods: {
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// SelectWithTextComponent.vue?6b3f1936